import apiClient from "@/api/client";
import type {
  GroupForecastSummary,
  ForecastSetEntry,
  SalaryReconciliation,
  ContractorLayerRow,
  ContractorGroupDetail,
  NonProjectSmearData,
  GroupSmearDetail,
  SuspensionPeriod,
  EmployeeProjectStatusEntry,
} from "@/features/finances/types/groupForecast";

export const groupForecastApi = {
  get: (year: number, month: number, horizon = 12) =>
    apiClient
      .get<{ data: GroupForecastSummary }>("/finances/group-forecast/", {
        params: { year, month, horizon },
      })
      .then((r) => r.data.data),

  set: (entries: ForecastSetEntry[]) =>
    apiClient
      .post<{ data: { written: number; removed: number } }>("/finances/group-forecast/set/", {
        entries,
      })
      .then((r) => r.data.data),

  reconciliation: (year: number, month: number) =>
    apiClient
      .get<{ data: SalaryReconciliation }>("/finances/salary-reconciliation/", {
        params: { year, month },
      })
      .then((r) => r.data.data),

  contractorLayers: () =>
    apiClient
      .get<{ data: ContractorLayerRow[] }>("/finances/contractor-layers/")
      .then((r) => r.data.data),

  contractorGroupDetail: (group: string) =>
    apiClient
      .get<{ data: ContractorGroupDetail }>("/finances/contractor-group-detail/", { params: { group } })
      .then((r) => r.data.data),

  smear: (year: number, month: number) =>
    apiClient
      .get<{ data: NonProjectSmearData }>("/finances/non-project-smear/", {
        params: { year, month },
      })
      .then((r) => r.data.data),

  setSmear: (entries: { group: string; fraction: string }[]) =>
    apiClient
      .post<{ data: { manual_active: boolean } }>("/finances/non-project-smear/", { entries })
      .then((r) => r.data.data),

  setEmployeeStatus: (entries: EmployeeProjectStatusEntry[]) =>
    apiClient
      .post<{ data: { written: number } }>("/finances/employee-project-status/set/", { entries })
      .then((r) => r.data.data),

  smearDetail: (group: string, year: number, month: number, horizon = 12) =>
    apiClient
      .get<{ data: GroupSmearDetail }>("/finances/group-smear-detail/", {
        params: { group, year, month, horizon },
      })
      .then((r) => r.data.data),

  setProjectSuspension: (project: string, periods: SuspensionPeriod[]) =>
    apiClient
      .post<{ data: { written: number } }>("/finances/project-suspension/set/", { project, periods })
      .then((r) => r.data.data),
};
